import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

BaseTextField.propTypes = {
    field: PropTypes.object.isRequired,
    fieldMeta: PropTypes.object,
    fieldHelper: PropTypes.object,

    type: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    text: PropTypes.string,
    className: PropTypes.string,
    spellCheck: PropTypes.bool,
};

BaseTextField.defaultProps = {
    type: "text",
    label: "",
    placeholder: "",
    disabled: false,
    text: "",
    spellCheck: false,

    fieldProps: {},
    fieldHelper: {},
    fieldMeta: {},

    className: 'form-group',
};

function BaseTextField(props) {
    // MARK: --- Params ---
    const { field, form, fieldHelper, fieldMeta, type,
        label, placeholder, disabled, text, className, spellCheck, asterisk } = props;
    const { name } = field;
    const { errors, touched } = form;
    const showError = (errors[name] && touched[name]) ?? false;

    return (
        <div className='BaseTextField'>
            <div className={className}>
                {
                    label && (<label htmlFor={name}>
                        {label}
                        {
                            asterisk && <span className="text-danger"> <b>(*)</b></span>
                        }
                    </label>)
                }
                <input
                    className={`form-control ${showError && 'is-invalid'}`}
                    id={name}
                    {...field}

                    disabled={disabled}
                    type={type}
                    placeholder={placeholder}
                    spellCheck={spellCheck}
                />
                {
                    text.length > 0 && (
                        <span className='form-text text-muted'>{text}</span>
                    )
                }
                {
                    showError && (
                        <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors[name]}</div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default BaseTextField;